<template lang="html">

    <section class="wrapper -actividad">

        
    </section>
  
  </template>
  
  <script lang="js">

    import {mapActions} from 'vuex';

    export default  {
      name: 'actividad',     
      mounted(){
        this.getData();
      },
      data(){
        return{
          data : ''
        }
      },
      methods : {
        ...mapActions(['']),
        getData(){
        }
      }
  }
  </script>
  
  


// WEBPACK FOOTER //
// src/components/views/actividad.vue